import { render, staticRenderFns } from "./TagsView.vue?vue&type=template&id=57b800e8&scoped=true&"
import script from "./TagsView.vue?vue&type=script&lang=js&"
export * from "./TagsView.vue?vue&type=script&lang=js&"
import style0 from "./TagsView.vue?vue&type=style&index=0&id=57b800e8&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./TagsView.vue?vue&type=style&index=1&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b800e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57b800e8')) {
      api.createRecord('57b800e8', component.options)
    } else {
      api.reload('57b800e8', component.options)
    }
    module.hot.accept("./TagsView.vue?vue&type=template&id=57b800e8&scoped=true&", function () {
      api.rerender('57b800e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/TagsView.vue"
export default component.exports